import { createActions, handleActions } from 'redux-actions';

const initState = {
  siteSetting: {},
};

export const creators = createActions({
  REPORT_SETTING_GET_REQUEST: () => ({}),
  REPORT_SETTING_UPDATE_REQUEST: (payload) => payload,
  REPORT_SETTING_SUCCESS: (payload) => payload,
  REPORT_SETTING_FAILURE: (payload) => payload,
});

const getReducer = (state) => {
  return { ...state, fetching: true, error: null };
};

const updateReducer = (state, { payload }) => {
  return { ...state, fetching: true, error: null, payload };
};

const successReducer = (state, { payload }) => {
  const nextState = Object.assign({}, state, payload);
  nextState.fetching = false;
  return nextState;
};

const failureReducer = (state, { payload }) => {
  return { ...state, fetching: false, error: payload };
};

export default handleActions(
  {
    REPORT_SETTING_GET_REQUEST: getReducer,
    REPORT_SETTING_UPDATE_REQUEST: updateReducer,
    REPORT_SETTING_SUCCESS: successReducer,
    REPORT_SETTING_FAILURE: failureReducer,
  },
  initState,
);
